<template>
    <NuxtLink v-if="url && url !== '#'" :to="'/' + url" class="w-full">
        <div
            v-if="item?.[imageKey]"
            class="relative flex aspect-[4/5] h-96 w-full items-end justify-center lg:h-[600px] lg:items-end xl:h-[595px] boxed:h-[600px]">
            <NuxtImg
                :src="useImageUrl(item[imageKey])?.format('webp')?.height(600).width(630).url() || ''"
                :alt="item?.title || ''"
                class="absolute inset-0 aspect-[4/5] h-96 w-full object-cover lg:h-full"
                width="630"
                height="600"
                loading="lazy"
                format="webp" />
            <BlockDoubleBannerContent :item="item" :formatted-title="formattedTitle" :url="url" />
        </div>
        <div v-else class="flex w-full items-center justify-center bg-gray-200 lg:h-[600px] lg:items-end">
            <BlockDoubleBannerContent :item="item" :formatted-title="formattedTitle" :url="url" />
        </div>
    </NuxtLink>

    <!-- Show content even without valid URL -->
    <div v-else class="w-full">
        <div
            v-if="item?.[imageKey]"
            class="relative flex h-96 w-full items-end justify-center lg:h-[600px] lg:items-end">
            <NuxtImg
                :src="useImageUrl(item[imageKey])?.format('webp')?.url() || ''"
                :alt="item?.title || ''"
                class="absolute inset-0 h-96 w-full object-cover object-center lg:h-full"
                width="630"
                height="600"
                loading="lazy"
                format="webp" />
            <BlockDoubleBannerContent :item="item" :formatted-title="formattedTitle" :url="url" />
        </div>
        <div v-else class="flex w-full items-center justify-center bg-gray-200 lg:h-[600px] lg:items-end">
            <BlockDoubleBannerContent :item="item" :formatted-title="formattedTitle" :url="url" />
        </div>
    </div>
</template>

<script setup lang="ts">
    defineProps<{
        url: string;
        item: any;
        formattedTitle: string;
        imageKey: string;
    }>();
</script>
